"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _never = require("rxjs/observable/never");

var _routes = _interopRequireDefault(require("./routes"));

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _default = {
  route: _UrlPathParams.THEMES,
  reducer: function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return state;
  },
  rootEpic: function rootEpic() {
    return (0, _never.never)();
  },
  routes: _routes.default
};
exports.default = _default;
module.exports = exports.default;